"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListSubheader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _ListSubheader = _interopRequireDefault(require("@material-ui/core/ListSubheader"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _excluded = ["className", "isSideNav"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: "inherit",
      userSelect: "none",
      fontSize: theme.typography.caption.fontSize
    },
    header: {
      color: theme.palette.text.secondary,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.caption.fontSize,
      padding: theme.spacing(0, 4),
      textTransform: "uppercase"
    },
    subheader: _objectSpread(_objectSpread({
      color: theme.palette.text.secondary
    }, theme.typography.caption), {}, {
      padding: theme.spacing(0, 4),
      lineHeight: theme.typography.body1.lineHeight
    })
  };
});

var ListSubheader = function ListSubheader(props) {
  var className = props.className,
      isSideNav = props.isSideNav,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_ListSubheader.default, (0, _extends2.default)({
    "aria-hidden": true // This item should not be read as part of the list. Instead use an aria-label on the list

  }, otherProps, {
    className: (0, _classnames.default)("prmbl-listSubheader", className, classes.root, (0, _defineProperty2.default)({}, classes.header, isSideNav === "header"), (0, _defineProperty2.default)({}, classes.subheader, isSideNav === "subheader"))
  }));
};

exports.ListSubheader = ListSubheader;
var _default = ListSubheader;
exports.default = _default;